<a
  class="pill"
  [routerLink]="value?.type === 'company'
    ? '/contacts/company/' + value.id
    : value?.type === 'society'
      ? '/contacts/society/' + value.id
      : '/contacts/person/' + value.id"
  (click)="$event.stopPropagation()"
>
  {{ value?.name }}
</a>
